// @flow

export const CLEAR_USER_DATA = "CLEAR_USER_DATA";
export const SAVE_USER_DATA = "SAVE_USER_DATA";
export const PASSWORD_REFRESHED = "PASSWORD_REFRESHED";
